<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <east_general_tab :location="location"></east_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <div>NOT_READY </div>
        </template>

        <template v-slot:location_logs="{ location, name }">
            <div>NOT_READY </div>
        </template>

        <template v-slot:location_products="{ location, name }">
            <div>NOT_READY </div>
        </template>


    </base_location_modal>
</template>

<script>
import base_location_modal from "../../../base/location_modal/base_location_modal";
import east_general_tab from "./tabs/east_general_tab";


export default {
    name: "east_location_modal",
    components : {
        east_general_tab,
        base_location_modal,
    },
    data () {
        return {
            tabs_add : [

            ]
        }
    },
}
</script>

<style scoped>

</style>
